import axios from 'axios';

export const getStatusesList = () => axios.get(`/status/info/list/`);
export const getStatusInfo = id => axios.get(`/status/info/${id}`);
export const getStatusDescription = () => axios.get(`/status/description/info/`);
